<template>
  <header
    id="1"
    :class="['header z-50 relative lg:mb-[3.75rem] lg:bg-white flex flex-col lg:block lg:h-auto', { 'min-h-0 h-screen': showSuperMenu}]"
  >
    <div
      class="lg:pt-24 text-sm flex lg:block px-4 lg:px-0"
      :class="showSuperMenu ? 'border-b' : ''"
    >
      <div
        id="2"
        class="sticky-header grow"
      >
        <div
          class="flex flex-col lg:flex-row lg:flex-wrap lg:container lg:mx-auto lg:items-center lg:h-full lg:justify-between gap-4"
        >
          <NavigationStoreLogo class="py-3" />
          <div
            v-if="showVersionBanner && version"
            class="version-banner absolute top-full left-0 w-full bg-primary-dark text-primary-contrast text-center text-xs py-1"
          >
            Version {{ version }}
          </div>
          <div class="lg:order-last relative items-center lg:grow flex gap-4">
            <div class="mobile-menu-trigger grow lg:hidden">
              <button
                class="flex flex-col items-center border-0 bg-transparent lg:px-2 text-primary lg:hidden"
                type="button"
                title="Menue"
                @click="
                  showSuperMenu = !showSuperMenu;
                  showMenu = false;
                  openDropdown = '0';
                  openSubDropdown = '0';
                "
              >
                <BasicIcon
                  v-if="!showSuperMenu"
                  name="menu"
                  :icon-class="'w-6 h-6'"
                />
                <BasicIcon
                  v-else
                  class="translate-x-1"
                  name="xmark-solid"
                  :icon-class="'w-6 h-6'"
                />
              </button>
            </div>
            <div v-if="!$device?.isDesktop && !$device?.isLighthouse">
              <div class="flex items-center gap-2">
                <template v-if="basisPaybackFeature && currentStore.paybackStore">
                  <div class="payback-logo-header">
                    <NuxtLink
                      :title="'PAYBACK'"
                      :to="'/shop/payback'"
                    >
                      <nuxt-img
                        densities="x1"
                        loading="lazy"
                        class="min-h-[26px]"
                        provider="cloudflare"
                        :src="'/97/27/77/05262c90ceebe43a34e6fdec70f562de6a/Payback-logo.svg'"
                        :alt="'PAYBACK'"
                      />
                    </NuxtLink>
                  </div>
                </template>
                <div class="relative pb-0.5">
                  <AccessabilityColorContrastSwitch
                    :position="'down'"
                    :icon-classes="'h-4 w-4'"
                  />
                </div>
                <div class="relative">
                  <div
                    class="lg:border-r lg:border-r-secondary-dark flex gap-3 lg:px-4 lg:py-2 mb-1 lg:my-2 hover:text-primary cursor-pointer items-center"
                  >
                    <NuxtLink
                      :to="'/shop/wishlist'"
                      aria-label="Zur Wunschliste"
                    >
                      <BasicIcon
                        class="w-6 h-6 text-primary cursor-pointer align-bottom"
                        :name="'heart-shape'"
                      />
                      <template v-if="useFeatureState('ES-5404-Counter')?.value == true">{{
                        wishListCounter
                      }}</template>
                    </NuxtLink>
                  </div>
                </div>
                <div class="relative">
                  <div
                    class="UserAccountButton lg:border-r lg:border-r-secondary-dark flex gap-3 lg:px-4 lg:py-2 lg:my-2 hover:text-primary cursor-pointer items-center"
                    :class="
                      showUserAccountDetails && !($device.isMobile || $device.isTablet) ? 'flyout-indicator' : ''
                    "
                    @click="toggleUserAccountPopUp"
                  >
                    <BasicIcon
                      class="w-6 h-6 text-primary"
                      :name="'circle-user-solid_02'"
                    />
                  </div>
                  <FlyOutsMyAccountFlyout
                    v-if="showUserAccountDetails"
                    @change-fly-out-state="changeUserAccountFlyOutState($event)"
                  />
                </div>
                <div class="lg:relative">
                  <div
                    v-if="!isFeatureEnabled || (!showLocalStoreDetails && !showStoreAssignInfo)"
                    class="LocalStoreButton flex gap-2 lg:px-4 hover:text-primary cursor-pointer items-center"
                    @click="toggleLocalStorePopUp"
                  >
                    <div class="grow text-base whitespace-nowrap">
                      <BasicIcon
                        :name="'location-dot-solid'"
                        class="w-4 inline-block text-primary"
                      />
                      <div class="hidden lg:inline-block">Mein Fachmarkt</div>
                    </div>
                  </div>
                  <div
                    v-if="isFeatureEnabled && (showLocalStoreDetails || showStoreAssignInfo)"
                    class="LocalStoreButton flex gap-2 lg:px-4 hover:text-primary cursor-pointer items-center"
                    @click="hideStoreAssignInfo"
                  >
                    <div class="grow text-base whitespace-nowrap">
                      <BasicIcon
                        :name="'location-dot-solid'"
                        class="w-4 inline-block text-primary"
                      />
                      <div class="hidden lg:inline-block">Mein Fachmarkt</div>
                    </div>
                  </div>
                  <FlyOutsLocalStoreFinderFlyout
                    v-if="showLocalStoreDetails"
                    @change-fly-out-state="toggleLocalStorePopUp($event)"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!showShoppingCartDetails"
              class="relative lg:btn-primary lg:order-last lg:text-primary-contrast text-primary cursor-pointer lg:flex gap-4 p-0 lg:p-4 font-normal lg:items-center"
              @click="toggleShoppingCartPopUp"
            >
              <BasicIcon
                class="w-5 h-5 lg:w-4 lg:h-4 align-text-bottom"
                :name="'cart-shopping-solid'"
              />
              <div class="hidden lg:block">Warenkorb</div>
              <div
                class="shoppingcart-counter"
              >
                {{ totalCartCount }}
              </div>
            </div>
            <template v-if="basisPaybackFeature && currentStore.paybackStore">
              <div class="payback-logo-header hidden lg:block order-2">
                <NuxtLink
                  :title="'PAYBACK'"
                  :to="'/shop/payback'"
                >
                  <nuxt-img
                    densities="x1"
                    loading="lazy"
                    class="min-h-[26px]"
                    provider="cloudflare"
                    :src="'/97/27/77/05262c90ceebe43a34e6fdec70f562de6a/Payback-logo.svg'"
                    :alt="'PAYBACK'"
                  />
                </NuxtLink>
              </div>
            </template>
            <div
              v-if="showShoppingCartDetails"
              class="relative lg:btn-primary lg:order-last lg:text-primary-contrast text-primary cursor-pointer lg:flex gap-4 p-0 lg:p-4 font-normal lg:items-center"
            >
              <BasicIcon
                class="w-5 h-5 lg:w-4 lg:h-4 align-text-bottom"
                :name="'cart-shopping-solid'"
              />
              <div class="hidden lg:block">Warenkorb</div>
              <div
                class="shoppingcart-counter"
              >
                {{ totalCartCount }}
              </div>
            </div>
            <BasicBtErrorBoundary>
              <FlyOutsShoppingCartFlyout
                v-if="showShoppingCartDetails"
                @change-fly-out-state="changeShoppingCartFlyOutState($event)"
              />
            </BasicBtErrorBoundary>
            <div class="lg:grow">
              <ClientOnly>
                <LayoutHeadSearchBox v-if="$device?.isDesktop" />
              </ClientOnly>
            </div>
          </div>
          <template v-if="isFeatureEnabled">
            <FlyOutsStoreAssignInfoFlyout
              v-if="showStoreAssignInfo"
              class="mobile-w-store-assign-info-flyout relative lg:hidden"
              @change-fly-out-state="hideStoreAssignInfo"
            />
          </template>
          <LayoutHeadSearchBox v-if="!$device?.isDesktop && !showSuperMenu" />
        </div>
      </div>
    </div>
    <ClientOnly>
      <div v-show="showSuperMenu" class="relative lg:hidden w-full flex-grow z-30">
        <div class="content-veil" />
        <NavigationMobile class="mobile-navigation" :super-category-tree="megaTree ?? []" @close-navigation="showSuperMenu = false" />
      </div>
    </ClientOnly>
    <div class="main-navigation hidden lg:container lg:mx-auto lg:flex lg:justify-between lg:items-start">
      <NavigationSuperMenu
        :super-category-tree="megaTree ?? []"
        :external="true"
        @show-mega-menu="showMenu = !showMenu"
      >
        <template #megamenu>
          <div class="shop-nav left-0 right-0 absolute lg:top-full">
            <NavigationMegaMenuComponent
              v-if="navigationTree != undefined && !$device.isLighthouse"
              :tree="navigationTree"
              :class="'megamenu-container lg:container lg:mx-auto z-20'"
              :navbarnavclass="'w-full'"
              :navlinkdropdownclass="'py-4 lg:py-5 px-2'"
              :limit="4"
              :basedir="'' + baseDir"
              :external="false"
              :moretitle="'mehr'"
              :morenavitemclass="'more'"
              :useinternburgericon="false"
              :dropdowncontainerclass="'left-0 right-0 mt-0 lg:top-7 group-hover:translate-y-8 p-4 z-10'"
              :show-menu="showMenu"
              :open-dropdown="openDropdown"
              :open-sub-dropdown="openSubDropdown"
              :multiplebanner="false"
              :showdesktopdropdownicon="false"
            >
              <template
                v-if="!dotwPending && dotw?.type == 'default' && dotw?.url !== undefined"
                #menuBannerContent
              >
                <aside
                  class="menue-banner text-paragraph p-4 bg-gradient-to-b from-[#ef7203] via-[#f7a501] to-[#ef7203]"
                >
                  <NuxtLink
                    :to="dotw?.url"
                    :external="!dotw?.url?.includes('.html')"
                    :title="dotw?.name"
                  >
                    <NuxtImg
                      class=""
                      :alt="dotw?.name && dotw?.name != '' ? dotw?.name : 'Angebot der Woche'"
                      :src="dotw?.imageSource"
                      preset="preview"
                    />
                    <div class="text-base py-2">{{ dotw?.name }}</div>
                    <div class="text-lg">{{ dotw?.description }}</div>
                  </NuxtLink>
                </aside>
              </template>
            </NavigationMegaMenuComponent>
          </div>
        </template>
      </NavigationSuperMenu>
      <div
        v-if="$device?.isDesktop || $device?.isLighthouse"
        class="user-interaction-side-menu flex items-center"
      >
        <div class="relative z-10">
          <div
            class="lg:border-r lg:border-r-secondary-dark flex gap-3 py-4 px-2 lg:px-4 lg:py-2 lg:my-2 hover:text-primary items-center"
          >
            <AccessabilityColorContrastSwitch
              :position="'down'"
              :icon-classes="'h-4 w-4'"
            />
          </div>
        </div>
        <div class="relative">
          <div
            class="lg:border-r lg:border-r-secondary-dark flex gap-3 py-4 px-2 lg:px-4 lg:py-2 lg:my-2 hover:text-primary cursor-pointer items-center"
          >
            <NuxtLink
              :to="'/shop/wishlist'"
              aria-label="Zur Wunschliste"
            >
              <BasicIcon
                class="w-6 h-6 text-primary cursor-pointer align-bottom"
                :name="'heart-shape'"
              />
              <sub v-if="useFeatureState('ES-5404-Counter')?.value == true">{{ wishListCounter }}</sub>
            </NuxtLink>
          </div>
        </div>
        <div class="relative">
          <div
            v-if="!showUserAccountDetails"
            class="UserAccountButton whitespace-nowrap lg:border-r lg:border-r-secondary-dark flex gap-3 py-4 px-2 lg:px-4 lg:py-2 lg:my-2 hover:text-primary cursor-pointer items-center"
            @click="toggleUserAccountPopUp"
          >
            <BasicIcon
              class="w-6 h-6 text-primary"
              :name="'circle-user-solid_02'"
            />
            <div class="grow text-base hidden lg:block">Mein Konto</div>
          </div>
          <div
            v-if="showUserAccountDetails"
            class="UserAccountButton flyout-indicator whitespace-nowrap lg:border-r lg:border-r-secondary-dark flex gap-3 py-4 px-2 lg:px-4 lg:py-2 lg:my-2 hover:text-primary cursor-pointer items-center"
          >
            <BasicIcon
              class="w-6 h-6 text-primary"
              :name="'circle-user-solid_02'"
            />
            <div class="grow text-base hidden lg:block">Mein Konto</div>
          </div>
          <FlyOutsMyAccountFlyout
            v-if="showUserAccountDetails"
            @change-fly-out-state="changeUserAccountFlyOutState($event)"
          />
        </div>
                  
        <div class="relative">
          <div
            v-if="!isFeatureEnabled || (!showLocalStoreDetails && !showStoreAssignInfo)"
            class="LocalStoreButton flex gap-2 lg:py-4 lg:px-4 hover:text-primary cursor-pointer items-center"
            @click="toggleLocalStorePopUp"
          >
            <div class="grow text-base whitespace-nowrap">
              <BasicIcon
                :name="'location-dot-solid'"
                class="w-4 lg:mr-2 lg:align-text-top inline-block text-primary"
              />
              <div class="hidden lg:inline-block">Mein Fachmarkt</div>
            </div>
          </div>
          <div
            v-if="isFeatureEnabled && (showLocalStoreDetails || showStoreAssignInfo)"
            class="LocalStoreButton flex gap-2 lg:py-4 lg:px-4 hover:text-primary cursor-pointer items-center"
            :class="showLocalStoreDetails ? 'flyout-indicator':''"
            @click="hideStoreAssignInfo"
          >
            <div class="grow text-base whitespace-nowrap">
              <BasicIcon
                :name="'location-dot-solid'"
                class="w-4 lg:mr-2 lg:align-text-top inline-block text-primary"
              />
              <div class="hidden lg:inline-block">Mein Fachmarkt</div>
            </div>
          </div>
          <template v-if="isFeatureEnabled">
            <FlyOutsStoreAssignInfoFlyout
              v-if="showStoreAssignInfo"
              @change-fly-out-state="hideStoreAssignInfo"
            />
            <FlyOutsLocalStoreFinderFlyout
              v-else-if="showLocalStoreDetails"
              @change-fly-out-state="toggleLocalStorePopUp($event)"
            />
          </template>
          <template v-else>
            <FlyOutsLocalStoreFinderFlyout
              v-if="showLocalStoreDetails"
              @change-fly-out-state="toggleLocalStorePopUp($event)"
            />
          </template>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { getDealOfTheWeek, getExpNavigationTree, recursiveSort } from '~/composables/ExpApi/expCache';
import { useSuperMenuState, useMobileMenuState , useShoppingCartItemsCount, useReservationCartItemsCount  } from '~/composables/states';
import { ProvideNames } from '#shared/statics';
import type { MenuLink } from '~~/models/Navigation';

defineProps({
  baseDir: {
    default: () => {
      return inject(ProvideNames.BASE_DIR);
    },
  },
});
const currentStore = useCurrentStore();
const { showVersionBanner, version } = useVersionBanner()

const shoppingCartCount = useShoppingCartItemsCount();
const reservationCartCount = useReservationCartItemsCount();
const totalCartCount = computed(
  () => (shoppingCartCount.value || 0) + (reservationCartCount.value || 0),
);

const wishListCounter = useWishListItemCount();
const route = useRoute();

const showSuperMenu = useSuperMenuState();
const showMenu = useMobileMenuState();
const openDropdown = ref('0');
const openSubDropdown = ref('0');

watch(
  route,
  () => {
    showSuperMenu.value = false;
    showMenu.value = false;
  },
  {
    deep: true,
    immediate: true,
  },
);

watch(
  showSuperMenu,
  () => {
    if (import.meta.client) {
      if(showSuperMenu.value == true) {
        document.body.classList.add('overflow-hidden')
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    }
  }
);

const showShoppingCartDetails = ref(false);
function changeShoppingCartFlyOutState(e) {
  if (!showShoppingCartDetails.value) {
    showShoppingCartDetails.value = true;
  } else {
    showShoppingCartDetails.value = false;
  }
}

// Reuse the shared navigation state that is already fetched and serialized once in
// app.vue (useState('navigation_tree<TAG>')). Previously this component issued its own
// useFetch with dedicated payload keys ('navigationTree-MAIN'/'navigationTree-SUPER'),
// which serialized a second full copy of the MAIN and SUPER navigation trees into the
// hydration payload (__NUXT_DATA__). The core-dump analysis measured the MAIN tree
// (1114 nodes) duplicated in the payload; deriving from the shared state removes that
// duplication (see nodejs_memory_leak_analyse.md, Priority 2).
const { data: mainTreeState } = getExpNavigationTree('MAIN');
const { data: superTreeState } = getExpNavigationTree('SUPER');

const navigationTree = computed<Array<MenuLink> | undefined>(() => {
  const result = mainTreeState.value;
  if (result && Array.isArray(result) && result.length > 0) {
    const res = result.filter((nav) => nav.primaryTree && nav.descendants?.length > 0);
    res?.forEach((cat) => recursiveSort(cat));
    res.sort((a, b) => b.position - a.position);
    return res;
  }
  return result;
});

const megaTree = computed<Array<MenuLink> | undefined>(() => {
  const result = superTreeState.value;
  if (result && Array.isArray(result) && result.length > 0) {
    const res = [...result];
    res?.forEach((cat) => recursiveSort(cat));
    res.sort((a, b) => b.position - a.position);
    return res.reverse();
  }
  return result as Array<MenuLink>;
});

function toggleSuperNavigation() {
  showSuperMenu.value = false;
}

const { pending: dotwPending, data: dotw } = await getDealOfTheWeek();

function toggleShoppingCartPopUp() {
  showShoppingCartDetails.value = !showShoppingCartDetails.value;
}

const showUserAccountDetails = ref(false);

function changeUserAccountFlyOutState(e) {
  if (!showUserAccountDetails.value) {
    showUserAccountDetails.value = true;
  } else {
    showUserAccountDetails.value = false;
  }
}

function toggleUserAccountPopUp() {
  showUserAccountDetails.value = !showUserAccountDetails.value;
}

const showLocalStoreDetails = ref(false);
const featureStateEXSI1765 = useFeatureState('exsi-1765');
const featureValueEXSI1765 = useFeatureValue('exsi-1765');

const isFeatureEnabled = computed(() => featureStateEXSI1765.value && featureValueEXSI1765.value);

const showStoreAssignInfo = ref(useStoreCookieInitialized().value);
const showStoreAssignInfoCookie = ref(useStoreCookieInitializedCookie());

if (showStoreAssignInfo.value) {
  showStoreAssignInfoCookie.value = true;
} else if (showStoreAssignInfoCookie.value && isFeatureEnabled.value) {
  showStoreAssignInfo.value = true;
}

function hideStoreAssignInfo() {
  showStoreAssignInfo.value = false;
  showStoreAssignInfoCookie.value = false;
}

function toggleLocalStorePopUp() {
  showLocalStoreDetails.value = !showLocalStoreDetails.value;
}

onNuxtReady(() => {
  try {
    window.addEventListener('CookiebotOnConsentReady', function (e) {
      const prefs = {
        REQUIRED: Cookiebot.consent.necessary,
        STATISTICS: Cookiebot.consent.statistics,
        MARKETING: Cookiebot.consent.marketing,
        PRODUCT_RATINGS: Cookiebot.consent.preferences,
      };
      refreshCookie('CookieConsent');
      for (const k in prefs) {
        useState('cookie' + k).value = prefs[k];
      }
    });
  } catch (error) {
    console.warn('error checking cookie permissions.', error);
  }
});
const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const basisPaybackFeature = computed(
  () =>
    featureStatePayback.value
    && (useFeatureValue('exsi-1556').value?.name == 'basic'
      || useFeatureValue('exsi-1556').value?.name == 'redemption'
      || useFeatureValue('exsi-1556').value?.name == 'full')
);
</script>
<style lang="postcss">
.content-veil {
  @apply absolute top-0 w-full bg-black h-full opacity-60 lg:hidden;
}
.mobile-navigation {
  @apply absolute bg-white w-[95%] h-full rounded-br-3xl;
}
.store-logo-dark {
  filter: hue-rotate(180deg);
}

.store-logo-dark-2 {
  filter: invert(1);
}
.shoppingcart-counter {
  @apply lg:shadow-[0_0_0_3px_rgb(var(--color-primary-dark))] py-0 px-1.5 left-3/4 lg:left-auto text-primary-contrast absolute text-xs lg:text-base bottom-full lg:bottom-auto bg-black lg:bg-primary-dark lg:relative rounded-full text-center block;
}
</style>
